export default "__VITE_ASSET__0qXB7lft__"